import { useCallback, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const HIGHLIGHT_DURATION_MS = 5000

type UseHighlightedRowResult = {
  highlightedId: string | null
  clearHighlight: () => void
}

export function useHighlightedRow(): UseHighlightedRowResult {
  const [searchParams, setSearchParams] = useSearchParams()
  const [highlightedId, setHighlightedId] = useState<string | null>(
    () => searchParams.get('highlight'),
  )

  const clearHighlight = useCallback(() => {
    setHighlightedId(null)
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev)
      next.delete('highlight')
      return next
    }, { replace: true })
  }, [setSearchParams])

  useEffect(() => {
    if (!highlightedId) return
    const timer = setTimeout(clearHighlight, HIGHLIGHT_DURATION_MS)
    return () => clearTimeout(timer)
  }, [highlightedId, clearHighlight])

  return { highlightedId, clearHighlight }
}
